<template>
  <div>

    <div class="mt-5 mb-5">
      <v-row dense>
        <v-col v-for="card in stats" :key="card.title" cols="12" md="3" sm="6" class="d-flex">
          <StatsCard class="flex-grow-1" :title="card.title" :value="card.value" :icon="card.icon" :color="card.color"
            :caption="card.caption" />
        </v-col>
      </v-row>
    </div>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <div>
              <span class="v-das-title-font">รายการข้อมูล Activity</span>
              <div class="subtitle-2 grey--text">
                จำนวนทั้งหมด {{ filteredData.length }} รายการ
              </div>
            </div>
            <v-spacer />
            <v-autocomplete
              class="mr-2"
              style="max-width: 250px !important"
              v-model="selectedActivityType"
              :items="activityTypes"
              label="เลือกดูข้อมูลตาม Group Type"
              dense
              filled
              hide-details
            ></v-autocomplete>
            <v-autocomplete
              style="max-width: 250px !important" 
              :items="years" 
              v-model="selectYear" 
              dense
              label="เลือกดูข้อมูลตามรอบการประเมิน PA" 
              filled 
              hide-details
            ></v-autocomplete>
          </v-card-title>

          <div class="pa-5">

            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search ... " single-line hide-details filled
              dense></v-text-field>

            <v-data-table class="table-bordered" :headers="headers" :items="filteredData" :search="search"
              :loading="loading">
              <template v-slot:item.status="{ item }">
                <v-chip :color="getStatusColor(item.status)" small dark label class="text-capitalize font-weight-bold">
                  {{ item.status }}
                </v-chip>
              </template>
              <template v-slot:item.name_academic="{ item }">

                <div class="text-left">
                  <p style="font-weight: 800;font-size: 14px;" class="mt-2 mb-2">
                    {{ item.name_academic }}
                  </p>

                  <p v-if="item.muic_account_aj" class="mb-2">
                    <span>InstructorCode :</span> {{ item.muic_account_aj.username }}
                  </p>

                  <div>
                    <span>Start:</span>&nbsp;&nbsp;
                    {{ formatThaiDate(item.date_start) }}
                  </div>

                  <div class="mb-2">
                    <span>End:</span>&nbsp;&nbsp;
                    <span class="highlight-end red--text font-weight-bold"> {{ formatThaiDate(item.date_end) }} </span> 
                  </div>

                  <!--  
                    <div class="mb-2">
                      <span>Year:</span>&nbsp;&nbsp;
                      {{ item.year_academic }}
                    </div>
                  -->
                  
                </div>

              </template>
              <template v-slot:item.history="{ item }">
                <v-list-item three-line>
                  <v-list-item-content>
                    <v-list-item-subtitle v-if="['reject', 'rejected'].includes(item.status)" class="red--text">
                       Remark : {{ item.status_remark }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      <p class="mt-0 mb-0">Update at : {{ formatThaiDateTime(item.updated_at) }}</p>
                      <p class="mt-0 mb-0">Create at : {{ formatThaiDateTime(item.created_at) }}</p>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>

              <!-- <template v-slot:item.action="{ item }"></template> -->

            </v-data-table>

          </div>
        </v-card>
      </v-col>
    </v-row>

  </div>
</template>

<script>

export default {
  name: 'DashboardView',
  data: () => ({
    selectedActivityType: 0,
    activityTypes: [],
    
    stats: [
      {
        key: 'approve',
        title: 'Active Approved',
        value: 0,
        icon: 'mdi-file-document-check',
        color: 'secondary',
        caption: ''
      },
      {
        key: 'send',
        title: 'Active Items waiting for review',
        value: 0,
        icon: 'mdi-clock-time-eight-outline',
        color: 'info',
        caption: ''
      },
      {
        key: 'reject',
        title: 'Active Items Reject',
        value: 0,
        icon: 'mdi-file-document-remove-outline',
        color: 'accent',
        caption: ''
      },
      {
        key: 'save',
        title: 'Saved (Draft)',
        value: 0,
        icon: 'mdi-content-save',
        color: 'primary',
        caption: ''
      }
    ],
    headers: [
      {
        sortable: false,
        text: "Title",
        value: "name_academic",
        align: "start",
        class: "font-weight-bold  blue-grey darken-3 white--text",
      },
      {
        sortable: false,
        text: "Type",
        value: "activity_type_detail.detail",
        align: "start",
        class: "font-weight-bold  blue-grey darken-3 white--text",
      },
      {
        sortable: false,
        text: "Hours",
        value: "point_activity",
        align: "end",
        class: "font-weight-bold  blue-grey darken-3 white--text",
      },
      {
        sortable: false,
        text: "Point",
        value: "point_activity",
        align: "end",
        class: "font-weight-bold  blue-grey darken-3 white--text",
      },
      {
        sortable: false,
        text: "Status",
        value: "status",
        align: "center",
        class: "font-weight-bold  blue-grey darken-3 white--text",
      },
      {
        sortable: false,
        text: "History",
        value: "history",
        align: "start",
        class: "font-weight-bold blue-grey darken-3 white--text",
      },
    //   {
    //     sortable: false,
    //     text: "",
    //     value: "action",
    //     align: "center",
    //     class: "font-weight-bold blue-grey darken-3 white--text",
    //   },
    ],

    dataActivity: [],
    loading: false,
    search: '',

    years: [],
    selectYear: null,

    showDetail: false,
    selectedActivity: {}
  }),

  watch: {
    selectYear() {
      this.getAdminActivityList()
    },
  },

  computed: {
    filteredData() {
      let result = this.dataActivity

      // 1. Exclude 'save' and 'send'
      result = result.filter(item => !['save', 'send'].includes(item.status))

      // 2. Filter by Activity Type (Group Type)
      if (this.selectedActivityType && this.selectedActivityType !== 0) {
        result = result.filter(item => item.activity_type_detail && item.activity_type_detail.id === this.selectedActivityType)
      }

      // Filter by PA evaluation period using date_end
      if (this.selectYear) {
        const { start, end } = this.getPaDateRange(this.selectYear)

        result = result.filter(item => {
          if (!item.date_end) return false
          return item.date_end >= start && item.date_end <= end
        })
      }

      return result
    }
  },

  created() {
    // Set selectYear before mounted/watchers to avoid duplicate API calls
    this.getPeriods()
    this.getActivityTypes()
  },
  mounted() {
    this.getAdminActivityList()
  },

  methods: {

    formatThaiDate(date) {
      if (!date) return '-'
      return this.$dayjs(date).locale('th').format('D MMMM BBBB')
    },
    formatThaiDateTime(date) {
      if (!date) return '-'
      return this.$dayjs(date).locale('th').format('D MMMM BBBB เวลา HH:mm น.')
    },

    statusColor(status) {
      if (status === 'On Track') return 'success'
      if (status === 'At Risk') return 'warning'
      if (status === 'Delayed') return 'error'
      return 'grey'
    },

    getPaDateRange(paYearBE) {
      const yearAD = paYearBE - 543

      return {
        start: `${yearAD - 1}-07-01`,
        end: `${yearAD}-06-30`
      }
    },

    async getPeriods() {
      this.years = [
        { value: null, text: 'ทั้งหมด' }
      ]
      const currentBE = new Date().getFullYear() + 543
      // Show 2 years ahead + current year + last 5 years
      for (let i = -2; i <= 5; i++) {
        const year = currentBE - i
        this.years.push({
          value: year,
          text: `PA ${year}`
        })
      }
      this.selectYear = currentBE
    },

    async getActivityTypes() {
      try {
        const response = await this.$http.get('/academic-service/activity-types/')
        if (response.status === 200) {
           this.activityTypes = [
             { text: 'Show All', value: 0 },
             ...response.data.map(item => ({
               text: item.detail,
               value: item.id
             }))
           ]
        }
      } catch (error) {
        console.error("Error fetching activity types:", error)
      }
    },

    getStatusColor(status) {
      switch (status) {
        case 'send':
          return 'blue darken-2';
        case 'save':
          return 'amber darken-3';
        case 'approve':
          return 'green darken-2';
        case 'rejected':
          return 'red darken-2';
        default:
          return 'grey darken-1';
      }
    },

    async getAdminActivityList() {
      this.loading = true
      this.dataActivity = []
      try {
        const resData = await this.$http.get(
          // ?year_academic=${this.selectYear}
          `/academic-service/main-activities/`
        )

        if ([200, 201].includes(resData.status)) {
          this.dataActivity = resData.data.map((item) => ({
            ...item,
            type: `${item.status}`,
          }))

          // Reset status counters
          const counter = {
            save: 0,
            send: 0,
            approve: 0,
            reject: 0
          }

          // Count activities by status, filtered by selected year
          let filteredForStats = this.dataActivity
          if (this.selectYear) {
            const { start, end } = this.getPaDateRange(this.selectYear)
            filteredForStats = this.dataActivity.filter(item => {
              if (!item.date_end) return false
              return item.date_end >= start && item.date_end <= end
            })
          }

          filteredForStats.forEach(item => {
            if (counter[item.status] !== undefined) {
              counter[item.status]++
            }
          })

          // Update stats cards (UI updates reactively)
          this.stats = this.stats.map(card => ({
            ...card,
            value: counter[card.key] || 0,
            caption: `updateAt ${this.$dayjs().locale('th').format('D MMM BBBB HH:mm')}`
          }))

        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },

  },
}
</script>

<style scoped>
::v-deep(.table-bordered table) {
  border-collapse: collapse;
  width: 100%;
}

::v-deep(.table-bordered th),
::v-deep(.table-bordered td) {
  border: 1px solid #ddd;
  padding: 8px;
}

::v-deep(.table-bordered th) {
  background-color: #f5f5f5;
  font-weight: bold;
}

.action-buttons {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 6px;
  /* gap between buttons */
}

@media (max-width: 480px) {
  .action-buttons {
    flex-direction: column;
    /* stack vertically on small screens */
    align-items: flex-start;
  }
}

.highlight-end {
  background-color: #fff9c4; /* light yellow highlight */
  padding: 0px 0px;
  border-radius: 4px;
}
</style>
